export type MarketRegime = "regular" | "pre-market" | "after-hours" | "closed";

/**
 * US equity session regime (all ET):
 *   pre-market  04:00–09:30 · regular 09:30–16:00 · after-hours 16:00–20:00
 *   closed      20:00–04:00 + weekends
 * DeltaTape's cash session is the `regular` window.
 */
export function getMarketRegime(now = new Date()): MarketRegime {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(now);
  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  if (map["weekday"] === "Sat" || map["weekday"] === "Sun") return "closed";

  const hour = Number(map["hour"]) % 24; // some runtimes emit "24" at midnight
  const minute = Number(map["minute"]);
  const m = hour * 60 + minute;

  const PRE_OPEN = 4 * 60;
  const REGULAR_OPEN = 9 * 60 + 30;
  const REGULAR_CLOSE = 16 * 60;
  const AFTER_CLOSE = 20 * 60;

  if (m < PRE_OPEN || m >= AFTER_CLOSE) return "closed";
  if (m < REGULAR_OPEN) return "pre-market";
  if (m < REGULAR_CLOSE) return "regular";
  return "after-hours";
}

export function isCashSession(now = new Date()): boolean {
  return getMarketRegime(now) === "regular";
}
